import { api } from "@/redux/api";

import {
	SendErrorRange,
	SupportCompaniesResponse,
	SupportCompaniesResponseSchema,
	SupportDashboardParams,
	SupportSendErrorResolved,
	SupportSendErrorResolvedSchema,
	SupportSendErrorsList,
	SupportSendErrorsListSchema,
	SupportSendErrorsOverview,
	SupportSendErrorsOverviewSchema,
	SupportUsersParams,
	SupportUsersResponse,
	SupportUsersResponseSchema,
} from "../../pages/SupportDashboard/schema/support-dashboard";

interface CompanySendErrorsArgs {
	companyId: number;
	range: SendErrorRange;
}

interface ResolveSendErrorArgs {
	scheduleId: number;
}

export const supportDashboardApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSupportCompanies: builder.query<SupportCompaniesResponse, SupportDashboardParams>({
			query: (params) => ({
				url: "support/companies",
				params: {
					...(params && { ...params }),
				},
				responseSchema: SupportCompaniesResponseSchema,
			}),
			providesTags: ["SupportDashboard"],
		}),
		getSupportUsers: builder.query<SupportUsersResponse, SupportUsersParams>({
			query: (params) => ({
				url: "support/users",
				params: {
					...(params && { ...params }),
				},
				responseSchema: SupportUsersResponseSchema,
			}),
			providesTags: ["SupportDashboard"],
		}),
		getSendErrorsOverview: builder.query<SupportSendErrorsOverview, SendErrorRange>({
			query: (range) => ({
				url: "support/send-errors/summary",
				params: { range },
				responseSchema: SupportSendErrorsOverviewSchema,
			}),
			providesTags: ["SupportDashboard"],
		}),
		getCompanySendErrors: builder.query<SupportSendErrorsList, CompanySendErrorsArgs>({
			query: ({ companyId, range }) => ({
				url: `support/companies/${companyId}/send-errors`,
				params: { range },
				responseSchema: SupportSendErrorsListSchema,
			}),
			providesTags: ["SupportDashboard"],
		}),
		resolveSendError: builder.mutation<SupportSendErrorResolved, ResolveSendErrorArgs>({
			query: ({ scheduleId }) => ({
				url: `support/send-errors/${scheduleId}/resolve`,
				method: "PATCH",
				responseSchema: SupportSendErrorResolvedSchema,
			}),
			invalidatesTags: ["SupportDashboard"],
		}),
	}),
});

export const {
	useGetSupportCompaniesQuery,
	useGetSupportUsersQuery,
	useGetSendErrorsOverviewQuery,
	useGetCompanySendErrorsQuery,
	useResolveSendErrorMutation,
} = supportDashboardApi;
